<template>
  <div class="formato_saida">
    <div class="form-group">
      <label for="FormatoDeSaida">Formato de Saída</label>
      <select class="form-control" id="FormatoDeSaida">
        <option value="mtx" disabled>MTX</option>
        <option value="charts" selected>Gráficos</option>
      </select>
    </div>
    <!-- <div class="form-group">
        <label>Optical Force:</label>
        <select class="form-control" id="input_type">
          <option>MTX</option>
          <option>Gráficos</option>
        </select>
    </div>-->
    <br />
    <div class="form-group">
      <label for="ElectromagneticField">Electromagnetic Field:</label>
      <select class="form-control" id="ElectromagneticField">
        <option>Opt 1</option>
        <option>Opt 2</option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  name: "formatoSaida"
};
</script>